import { push } from 'react-router-redux';
import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActionResult, apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { currentUserSelector } from '../selectors';
import { RESOURCES, USER_RESOURCE_ENDPOINT } from './endpoints';
import getUserConfiguration from './get';

const actions = createActions({
  USER: {
    SUBSCRIBE_PLAN: (sourceToken, nextUrl) => ({ sourceToken, nextUrl }),
    API: {
      SUBSCRIBE_PLAN: apiResourceActionCreator('subscription')
    }
  }
})

export const apiAction = (authToken, payload) => commonApiActions.authenticated.post(USER_RESOURCE_ENDPOINT(RESOURCES.Subscription), authToken, payload, actions.user.api.subscribePlan)

export function* subscribePlan(action) {
  const authToken = yield select(authTokenSelector);

  yield put(apiAction(authToken, action.payload.sourceToken));

  const subscribeResult = yield apiActionResult(actions.user.api.subscribePlan);

  if (subscribeResult.success) {

    const currentUser = yield select(currentUserSelector)

    yield put(getUserConfiguration.action.user.get(currentUser.id));

    const userResult = yield apiActionResult(getUserConfiguration.action.user.api.get);

    if (userResult.success) {
      yield put(push({ pathname: action.payload.nextUrl }));
    }
  }
}

const configuration = {
  name: 'subscribePlan',
  action: actions,
  sagas: subscribePlan,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetching: true
    }),
    success: (state, action) => ({
      ...state,
      error: null,
      currentSubscription: action.payload.subscription,
      isFetching: false
    }),
    failed: (state, action) => ({
      ...state,
      error: action.payload.error,
      isFetching: false
    }),
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/user/configurations/subscribePlan.js